import { Injectable } from '@angular/core';
import { sampleMitiData } from './data/miti-data';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { BehaviorSubject, map, Observable} from 'rxjs';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';

@Injectable({
    providedIn: 'root',
})
export class GrantsService {
    mitiData: any = sampleMitiData;
    public mitiSubject = new BehaviorSubject(false);
    constructor(private _apiService: ApiService) {}

    getMitiData(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.GRANTS).pipe(
            map((data: any) => {
                return data[0]?.products;
            })
        );
    }

    isClickedOnStart(data) {
        this.mitiSubject.next(data);
    }
}
